"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrueSizeView = exports.CSS = void 0;
const theme_1 = require("../../../components/theme");
const mithril_1 = require("../../../mithril");
const services_1 = require("../../../services");
const capture_thumbnail_1 = require("../../capture.thumbnail/capture.thumbnail");
exports.CSS = {
    capture: 'c-TrueSize__capture'
};
(0, theme_1.addStyles)({
    [exports.CSS.capture]: {
        padding: theme_1.DefaultTheme.space(1)
    }
});
exports.TrueSizeView = {
    viewInline(field) {
        const captures = field.getCaptures();
        if (captures.length > 0) {
            return String(captures.length);
        }
        return '';
    },
    hasDetail(field) {
        return field.getCaptures().length > 0;
    },
    viewDetail(field) {
        const captures = [];
        const className = exports.CSS.capture;
        const imageCtx = { truesize: true, className, title: '' };
        const collection = field.collection;
        for (const capture of field.getCaptures()) {
            imageCtx.title = services_1.Services.DateTime.formatDateTime(capture.collectedAt.iso);
            const dom = capture_thumbnail_1.CaptureThumbnail.view(collection, capture, imageCtx);
            captures.push(dom);
        }
        return mithril_1.m.fragment({}, captures);
    },
    viewEdit(field, state) {
        return exports.TrueSizeView.viewInline(field, state);
    },
    hasClear(field) {
        return false;
    }
};
//# sourceMappingURL=true.size.view.js.map